import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'rt-list-sortable-form',
  templateUrl: './list-sortable-form.component.html',
  styleUrls: ['./list-sortable-form.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListSortableFormComponent implements OnInit {
  @Input() public value: string;
  @Input() public processing: boolean = false;
  @Output() public saveClick: EventEmitter<string> = new EventEmitter();
  @Output() public cancelClick: EventEmitter<void> = new EventEmitter();

  public nameForm: FormGroup;

  private ngOnDestroy$: Subject<void> = new Subject();

  constructor(private formBuilder: FormBuilder, private cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.nameForm = this.formBuilder.group({
      name: [this.value, Validators.required],
    });
    this.nameForm.valueChanges
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(() => this.cdRef.detectChanges());
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public save(): void {
    if (!this.nameForm.valid || this.nameForm.get('name')!.value === this.value) {
      return;
    }

    this.processing = true;
    this.saveClick.emit(this.nameForm.get('name')!.value);
  }

  public cancel(): void {
    this.cancelClick.emit();
  }
}
